import { useTracker } from "contexts/tracker";
import type { MouseEventHandler, ReactElement } from "react";
import React from "react";

interface InjectedOnClickProps {
    onClick?: MouseEventHandler<any>;
    [key: string]: any;
}

export default function TrackedButton({
    children,
    action,
}: {
    children: ReactElement<InjectedOnClickProps>;
    action: string;
}) {
    const tracker = useTracker();

    return React.Children.map(children, (child) => {
        if (React.isValidElement<InjectedOnClickProps>(child)) {
            const originalOnClick = child.props.onClick;

            return React.cloneElement(child, {
                onClick: (event: React.MouseEvent<any, MouseEvent>) => {
                    if (tracker) {
                        tracker.trackEvent("Button clicked", {
                            button: action,
                        });
                    }

                    if (originalOnClick) {
                        originalOnClick(event);
                    }
                },
            });
        }
        return child;
    });
}
